export default __webpack_public_path__ + "static/media/nato.ee323b9a.svg";